import { render, staticRenderFns } from "./BtnAcoesLotesSelecionados.vue?vue&type=template&id=244c162a&"
import script from "./BtnAcoesLotesSelecionados.vue?vue&type=script&lang=js&"
export * from "./BtnAcoesLotesSelecionados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports